<!-- 简版采编名片 -->
<template>
  <div class="">
    <div class="plain-card">
      <div class="left">
        <img :src="$global.imgUrl + perInfo.coverImg" alt="" />
      </div>
      <div class="right">
        <p>
          ISSN：<span>{{ perInfo.issn }}</span>
        </p>
        <p>
          CN：<span>{{ perInfo.cn }}</span>
        </p>
        <p>
          {{ $global.publishPeriod(perInfo.publishPeriod) }} |
          <span>{{ perInfo.publishAddrProvince }}</span>
        </p>
      </div>
    </div>
    <div class="button" v-if="path !== 'progressQuery'">
      <div class="left" @click="consult" :class="userId == editId ? 'zhe' : ''">
        <img src="../../public/mobileImg/icon9.png" alt="" />
        <span>咨询</span>
      </div>
      <div class="right" @click="openModal">
        <img src="../../public/mobileImg/icon4.png" alt="" />
        <span>投稿</span>
      </div>
    </div>
    <div class="button" v-if="path == 'progressQuery'" @click="openModal">
      <img src="../../public/mobileImg/icon4.png" alt="" />
      <span>投稿</span>
    </div>
    <!-- 投稿提醒组件 -->
    <contributeModal
      :showModal="showModal"
      :journalName="journalName"
      @closeModal="showModal = false"
    />
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import contributeModal from "@/components/contribute_modal";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { contributeModal },
  data() {
    //这里存放数据
    return {
      path: "",
      // editId: '1446352177927950336', // 后期从url中获取
      editId: this.$route.query.editId,
      // perId: '1297783010043576320', // 后期从url中获取
      perId: this.$route.query.perId,
      userId: JSON.parse(sessionStorage.getItem("userInfo"))
        ? JSON.parse(sessionStorage.getItem("userInfo")).user.id
        : "",
      perInfo: {},
      showModal: false,
      journalName: "",
      canBtn: false,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 打开投稿弹窗
    openModal() {
      if (this.canBtn) return;
      if (this.perInfo.name === undefined) {
        this.$Message.error("投稿失败,请重试");
        return;
      }
      this.journalName = "";
      if (sessionStorage.getItem("token")) {
        if (this.perInfo.cn === "" || this.perInfo.contribute === 0) {
          this.journalName = this.perInfo.name;
        }
        this.showModal = true;
      } else {
        this.$Message.error("还没有登录,请登录");
        this.$router.push({
          path: "/login",
          query: {
            perId: this.$route.query.perId,
            editId: this.$route.query.editId,
          },
        });
      }
    },
    // 咨询
    consult() {
      if (this.userId == this.editId) {
        return;
      }
      let token = sessionStorage.getItem("token");
      let card = JSON.parse(sessionStorage.getItem("cardInfo"));
      if (token) {
        if (card.hasOwnProperty("groupId")) {
          this.$router.push({
            path: "/consult",
            query: {
              name: card.name,
              perName: card.perName,
              perId: card.perId,
              groupId: card.groupId,
              userId: card.userId,
              perLogo: card.perLogo,
            },
          });
        } else {
          this.$router.push({
            path: "/consult",
            query: {
              name: card.name,
              perName: card.perName,
              perId: card.perId,
              groupId: "",
              userId: card.userId,
              perLogo: card.perLogo,
            },
          });
        }
      } else {
        this.$Message.error("请登录后咨询!");
        this.$router.push({
          path: "/login",
          query: {
            perId: this.$route.query.perId,
            editId: this.$route.query.editId,
          },
        });
      }
    },
    // 获取期刊信息
    getPer() {
      this.canBtn = true;
      this.$apis.manage
        .jourShow({
          perId: this.$route.query.perId,
        })
        .then((result) => {
          this.canBtn = false;
          this.perInfo = result.content.vo;
        })
        .catch((err) => {
          this.canBtn = false;
          // console.log(err);
        });
    },

    getRouter() {
      this.path = this.$router.history.current.name;
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getRouter();
    this.getPer();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.plain-card {
  padding: 28px 18px 22px 18px;
  background-color: #fff;
  display: flex;
  .left {
    margin-right: 18px;
    img {
      width: 87px;
      height: 114px;
    }
  }
  .right {
    p {
      font-size: 16px;
      font-family: Source Han Sans SC;
      font-weight: 400;
      color: #444444;
      line-height: 31px;
    }
  }
}
.button {
  height: 52px;
  border-top: 1px solid #e6e6e6;
  border-bottom: 1px solid #e6e6e6;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  img {
    width: 18px;
    height: 18px;
    margin-right: 7px;
  }
  span {
    font-size: 16px;
    color: #2150cb;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 50%;
    &:nth-child(1) {
      border-right: 1px solid #e6e6e6;
    }
    img {
      width: 18px;
      height: 18px;
      margin-right: 7px;
    }
    span {
      font-size: 16px;
      color: #2150cb;
    }
  }
}
</style>
